'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */
/* Copyright (c) 2017 Mobify Research & Development Inc. All rights reserved. */
/* * *  *  * *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  *  * */

exports.default = {
    ASK_SCRIPT: 'non-pwa-ask.js',
    ASK_CSS: 'non-pwa-ask.css',
    BUTTON_CONTAINER_CLASS: 'js-button-container',
    BUTTON_DENY_ID: 'js-deny',
    BUTTON_ALLOW_ID: 'js-allow',
    ASK_IFRAME_ID: 'mobify-messaging-iframe'
};


//////////////////
// WEBPACK FOOTER
// ./~/progressive-web-sdk/dist/non-pwa/messaging/constants.js
// module id = 134
// module chunks = 0